module.exports = __webpack_public_path__ + "img/horizontal_3_4_pp1_6000.77cb3c06.png";